import { Link } from "react-router-dom";

import { Divider, Row, Col } from "antd";
import { deleteFromLocalStorage } from "../../../../helpers/localstorage";
import { useHistory } from "react-router-dom";
import { useRoutesSomethingChanged } from "context/RoutesCofirmChangesContext";

export default function MenuFooter(props) {
  const history = useHistory();

  const { somethingChanged, showUnsaveConfirm } = useRoutesSomethingChanged();

  const handleLinkClick = (event, to) => {
    if (somethingChanged) {
      event.preventDefault();
      showUnsaveConfirm(() => {
        history.push(to);
        deleteFromLocalStorage(["token", "isSuperAdmin"]);
      });
    } else {
      deleteFromLocalStorage(["token", "isSuperAdmin"]);
    }
    props.onClose();
  };

  return props.collapsed === false ? (
    <Row
      className="hp-sidebar-footer hp-bg-color-dark-90"
      align="middle"
      justify="space-between"
    >
      <Divider className="hp-border-color-black-40 hp-border-color-dark-70 hp-mt-0" />

      <Col style={{ display: "flex", justifyContent: "center", flex: 1 }}>
        <Link
          to="/"
          onClick={(e) => handleLinkClick(e, "/")}
          style={{ display: "flex", alignItems: "center", gap: "12px" }}
        >
          <span
            className="hp-d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body"
            style={{ lineHeight: 1, fontSize: 20 }}
          >
            Log Out
          </span>
          <i
            className="hp-text-color-black-100 hp-text-color-dark-0 ph-fill ph-sign-out"
            style={{ fontSize: 24 }}
          />
        </Link>
      </Col>
    </Row>
  ) : (
    <Row
      className="hp-sidebar-footer hp-bg-color-dark-90"
      align="middle"
      justify="center"
    >
      <Col>
        <Link
          to="/"
          onClick={(e) => handleLinkClick(e, "/")}
          style={{ display: "flex", alignItems: "center", gap: "12px" }}
        >
          <i
            className="hp-text-color-black-100 hp-text-color-dark-0 ph-fill ph-sign-out"
            style={{ fontSize: 24 }}
          />
        </Link>
      </Col>
    </Row>
  );
}
